import Aos from "../components/aos";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import FloatingShapes from "../components/FloatingShapes";
/**
 * 404 Page
 */
const Page404 = ($) => {
	if ($("body").hasClass("error404")) {
		Aos();
		gsap.registerPlugin(ScrollTrigger); // intialize scrollTrigger using Gsap and pass down

		FloatingShapes(gsap, 5);
	}
};

export default Page404;
